import React, {FC} from 'react';
import adopted from '../../assets/images/icon-page/adopted.png';


const AdoptedIcon: FC<{ size?: number | string; alt?: string }> = ({size = 24, alt = 'Adopted Icon'}) => {
    return (
        <img
            src={adopted}
            alt={alt}
            style={{width: size, height: size, display: 'block'}}
        />
    );
};

export default AdoptedIcon;
